import React from 'react';
import { Route } from 'react-router-dom';
import { AppRoute } from './routes.config';
import { Guard } from '@/state/store/auth/guard';

/**
 * Recursively renders an array of route configurations into React Router `<Route>` components.
 * Automatically wraps private routes in an authentication `<Guard>` component.
 * 
 * @param routes - An array of route configuration objects.
 * @returns An array of rendered `<Route>` components.
 */
export const renderRoutes = (routes: AppRoute[]) => {
  return routes.map((route, index) => {
    const { path, index: isIndex, element, children, isPrivate } = route;

    // Determine the element to render, wrapping in Guard if it's private
    let routeElement = element;
    if (isPrivate && element) {
      routeElement = <Guard>{element}</Guard>;
    }

    if (children && children.length > 0) {
      return (
        <Route
          key={path || index}
          path={path}
          element={routeElement}
        >
          {renderRoutes(children)}
        </Route>
      );
    }

    if (isIndex) {
      return (
        <Route
          key={path || index}
          index
          element={routeElement}
        />
      );
    }

    return (
      <Route
        key={path || index}
        path={path}
        element={routeElement}
      />
    );
  });
};
